import React from 'react';
import PropTypes from 'prop-types';
import Background from 'components/common/Background';
import { Card, Col, Row, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Logo from 'components/common/Logo';

const AuthSplitLayoutLogin = ({ children, bgProps }) => {
  return (
    <Container fluid>
      <Row className="min-vh-100 bg-100">
        <Col xs={6} className="d-none d-lg-block position-relative overflow-hidden">
          {bgProps && <Background {...bgProps} />}
        </Col>
        <Col sm={10} md={6} className="px-sm-0 align-self-center mx-auto py-5">
          <Row className="g-0 justify-content-center">
            <Col lg={11} xl={10} className="col-xxl-9">
              <Card style={{ minHeight: '600px' }}> {/* 👈 increased height */}
                <Card.Header
                  className="d-flex justify-content-center align-items-center"
                  style={{ height: '100px' }} // 👈 taller header
                >
                  <Logo at="login" width={250} />
                </Card.Header>
                <Card.Body className="p-5 d-flex flex-column justify-content-center">
                  {children}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

AuthSplitLayoutLogin.propTypes = {
  children: PropTypes.node.isRequired,
  bgProps: PropTypes.shape(Background.propTypes).isRequired
};

export default AuthSplitLayoutLogin;
